import { Radio } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface LiveDemoToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  className?: string;
  variant?: 'icon' | 'switch';
}

/**
 * Toggle for enabling live demo mode with simulated data updates
 * - icon variant: Just an icon button (for mobile header)
 * - switch variant: Toggle switch with label (for desktop dashboard)
 */
export function LiveDemoToggle({
  enabled,
  onChange,
  className,
  variant = 'icon'
}: LiveDemoToggleProps) {
  if (variant === 'icon') {
    return (
      <Button
        variant="ghost"
        size="icon"
        className={cn("h-9 w-9 relative", className)}
        onClick={() => onChange(!enabled)}
        title={enabled ? 'Live updates on' : 'Live updates off'}
      >
        <Radio className={cn(
          "h-5 w-5 transition-colors",
          enabled && "text-[#8FB560]"
        )} />
        {enabled && (
          <span className="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-[#8FB560] animate-pulse" />
        )}
      </Button>
    );
  }

  // Switch variant for desktop
  return (
    <button
      onClick={() => onChange(!enabled)}
      className={cn(
        "flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors",
        className
      )}
    >
      <span className="relative flex items-center">
        <Radio className={cn(
          "h-4 w-4 transition-colors",
          enabled && "text-[#8FB560]"
        )} />
        {enabled && (
          <span className="absolute -top-0.5 -right-0.5 h-1.5 w-1.5 rounded-full bg-[#8FB560] animate-pulse" />
        )}
      </span>
      <span className={cn(enabled && "text-[#8FB560]")}>
        Live
      </span>
    </button>
  );
}
